import { createReportConfiguration, IReportConfiguration, ISavedView } from '@opengov/reporting-types';

export interface IReportHistory {
  reportConfiguration: Partial<IReportConfiguration>;
  savedView?: ISavedView;
}

export interface IReportHistoryState {
  history: IReportHistory[];
}

export const createReportHistory = (values: Partial<IReportHistory> = {}): IReportHistory => ({
  savedView: null,
  ...values,
  reportConfiguration: values.reportConfiguration
    ? createReportConfiguration(values.reportConfiguration)
    : createReportConfiguration()
});
